module.exports = __webpack_public_path__ + "static/media/track.c0223bed.svg";